import { Card, Input, Select } from "components";
import { useDepartement, useDivisi } from "pages/Card/Transaction/CreateNewEmployee/components/FormSection/utils";
import { useListDropdownSchedule } from "../../hooks";
import {  useListFilter } from "../../stores";
import { debounce } from "lodash";

export function FilterList() {

    // state
    const { filter, setFilter } = useListFilter()

    // hooks
    const { dataDepartement, isLoadingDepartement } = useDepartement()
    const { data: dataDivisi, isLoading: isLoadingDivisi } = useDivisi()
    const { data: dataSchedule, isLoading: isLoadingSchedule } = useListDropdownSchedule({})

    const onDebounce = debounce((e: any) => {
        setFilter({ keyword: e.target.value });
    }, 300);


    return (
        <div className="sticky top-[125px] py-4 z-[2] bg-white dark:bg-black">
            <Card>
                <Card.Body>

                    <div className="flex gap-2 items-end">
                        <div className="flex gap-2 items-end">
                            <Select
                                label="SCHEDULE"
                                placeholder="Select schedule..."
                                className="lg:w-[500px] md:w-full me-2"
                                width={true}
                                isLoading={isLoadingSchedule}
                                options={dataSchedule}
                                value={dataSchedule.find(
                                    (item) => item.value === filter?.shift_schedule_id?.toString())}
                                onChange={(e) => {
                                    const schedule = dataSchedule.find((item) => item.value === e?.value)

                                    setFilter({
                                        ...filter,
                                        shift_schedule_id: e?.value ?? "",
                                        date_start: schedule?.periode_start,
                                        date_end: schedule?.periode_end,
                                        shift_schedule_code: schedule?.trx_code
                                    })

                                }
                                }
                            />

                            <Select
                                label="DIVISI"
                                placeholder="Select job position"
                                className="lg:w-[300px] md:w-full me-2"
                                width={true}
                                isLoading={isLoadingDivisi}
                                options={[{ label: "ALL", value: "" }, ...dataDivisi]}
                                value={
                                    dataDivisi.find((item) => item.value === filter?.divisi) ??
                                    { label: "ALL", value: "" }
                                }
                                onChange={(e) =>
                                    setFilter({ ...filter, divisi: e?.value ?? "" })
                                }
                            />
                            <Select
                                label="DEPARTMENT"
                                placeholder="Select department..."
                                className="lg:w-[300px] md:w-full me-2"
                                width={true}
                                isLoading={isLoadingDepartement}
                                options={[{ label: "ALL", value: "" }, ...dataDepartement]}
                                value={dataDepartement.find(
                                    (item) => item.value === filter?.department) ??
                                    { label: "ALL", value: "" }}
                                onChange={(e) =>
                                    setFilter({ ...filter, department: e?.value ?? "" })
                                }
                            />
                        </div>
                    </div>

                    <div className="flex justify-between items-end">
                        <div className="flex gap-2 mb-3 items-center">
                            <div>
                                <Input
                                    label="SEARCH"
                                    className="lg:w-[300px] md:w-full"
                                    placeholder="Search data..."
                                    onChange={onDebounce}
                                />
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}